import React from 'react'
import Header from '../components/Header'
import Wrapper from '../components/Wrapper'

const Home = () => {
    return (
        <Wrapper>
            <Header>Home</Header>
        </Wrapper>
    )
}

export default Home